import { useQuery, UseQueryOptions } from "react-query";
import { IModel, Route } from "@edgetier/watchtower-types";
import { AxiosError } from "axios";
import { axios } from "utilities/axios";
import { IModelsGetQueryParameters } from "@edgetier/watchtower-types/src";

/**
 * Request the models from the backend.
 * @returns An array of models.
 */
const requestModels = async (url: string, queryParameters: IModelsGetQueryParameters) => {
    const { data } = await axios.get<{ items: IModel[] }>(url, { params: queryParameters });
    return data.items;
};

/**
 * A query for requesting models from the backend.
 * @param options React query options passed to the request
 */
export const useModels = <T = IModel[]>(
    queryParameters: IModelsGetQueryParameters = {},
    options: Omit<UseQueryOptions<IModel[], AxiosError, T>, "queryKey" | "queryFn"> = {}
) => {
    const url = Route.Models;
    return useQuery<IModel[], AxiosError, T>(
        [url, queryParameters],
        () => requestModels(url, queryParameters),
        options
    );
};
